var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('swiper',{staticClass:"details-swiper",attrs:{"showIndicator":true}},_vm._l((_vm.topImages),function(item,i){return _c('swiper-item',{key:i},[_c('img',{attrs:{"src":item},on:{"load":_vm.swiperLoading}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }